import { EFirstMessageActionTypes } from '../../actions/firstMessage';
import { BLOB_ID } from '../../constants/blobId';
import { TAppState } from '../../types/appState';
import { EFirstMessageStatus } from '../../types/firstMessageStatus';
import { TReduxActions } from '../../types/redux/actions';

export function firstMessageReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EFirstMessageActionTypes.Pending:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.Pending,
          },
        },
      };
    case EFirstMessageActionTypes.Sent:
      const { chatId, lastMessage } = action.payload.chat;

      if (!chatId || !lastMessage) {
        return state;
      }

      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.Sent,
            newChatId: chatId,
          },
        },
      };
    case EFirstMessageActionTypes.NeedCaptcha:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.NeedCaptcha,
          },
        },
      };
    case EFirstMessageActionTypes.NeedConfirmPhone:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.NeedConfirmPhone,
          },
        },
      };
    case EFirstMessageActionTypes.ChatsBlocked:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.ChatsBlocked,
          },
        },
      };
    case EFirstMessageActionTypes.UserChatsDisabled:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.ChatsDisabled,
          },
        },
      };
    case EFirstMessageActionTypes.Failed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.Failed,
          },
        },
      };

    case EFirstMessageActionTypes.ValidationError:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [BLOB_ID]: {
            ...state.openedChats[BLOB_ID],
            firstMessageStatus: EFirstMessageStatus.ValidationError,
          },
        },
      };

    default:
      return state;
  }
}
